import React from 'react';
import { CopyToClipboard, Embolden } from '@beeline.com/bp-design-system';

interface TruncatedTextProps {
  textCopy: string;
  emboldenSearchTerm?: string;
  enableEllipsis?: boolean;
  tooltipOnlyWithEllipsis?: boolean;
  dataTest?: string;
}

export const TruncatedCopy: React.FC<React.PropsWithChildren<TruncatedTextProps>> = ({
  textCopy,
  emboldenSearchTerm,
  enableEllipsis = true,
  tooltipOnlyWithEllipsis = true,
  dataTest
}) => (
  <CopyToClipboard
    dataTest={dataTest}
    tooltipText={textCopy}
    valueToCopy={textCopy}
    tooltipOnlyWithEllipsis={tooltipOnlyWithEllipsis}
    enableEllipsis={enableEllipsis}
  >
    {emboldenSearchTerm ? <Embolden term={emboldenSearchTerm}>{textCopy}</Embolden> : textCopy}
  </CopyToClipboard>
);
